const paths = {
  "angle-right":
    "M273 239c9.4 9.4 9.4 24.6 0 33.9L113 433c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l143-143L79 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L273 239z",
  "angle-down":
    "M241 337c-9.4 9.4-24.6 9.4-33.9 0L47 177c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 337z",
  spinner:
    "M288 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM448 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM32 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM75 437a32 32 0 1 0 45.3-45.3A32 32 0 1 0 75 437zm316.8 0A32 32 0 1 0 437 391.8 32 32 0 1 0 391.8 437zM75 75a32 32 0 1 0 45.3 45.3A32 32 0 1 0 75 75z",
};

export const icon = (name: "angle-right" | "angle-down" | "spinner") => {
  var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("aria-hidden", "true");
  svg.setAttribute("focusable", "false");
  svg.setAttribute("data-prefix", "far");
  svg.setAttribute("data-icon", name);
  svg.setAttribute("class", `svg-inline--fa fa-${name}`);
  if (name == "spinner") svg.setAttribute("class", "svg-inline--fa fa-spinner fa-spin ");
  svg.setAttribute("role", "img");
  svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  if (name == "angle-right") svg.setAttribute("viewBox", "0 0 320 512");
  if (name == "angle-down") svg.setAttribute("viewBox", "0 0 448 512");
  if (name == "spinner") svg.setAttribute("viewBox", "0 0 512 512");

  // Create a path element and set its attributes
  var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
  path.setAttribute("fill", "currentColor");
  path.setAttribute("d", paths[name]);

  // Append the path to the SVG element
  svg.appendChild(path);

  return svg;
};
